// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error[data-v-1e5b30c2] {\n  background: #F4F4F4;\n  height: 99vh;\n  border: solid 1px #f4f4f4;\n}\n.error .nav[data-v-1e5b30c2] {\n    width: 400px;\n    margin: 0 auto;\n    text-align: center;\n}\n.error .nav p[data-v-1e5b30c2] {\n      font-size: 150px;\n      color: #CCCCCC;\n}\n.error .nav span[data-v-1e5b30c2] {\n      color: #CCCCCC;\n}\n", ""]);
// Exports
module.exports = exports;
